// lint rule not applicable to V2 components
import { Dialog } from '@mui/material';
import Markdown, { defaultUrlTransform } from 'react-markdown';

import Icon, { IconName } from '@/components/Icon/Icon';

import useStyles from './FormResultDialog.styles';

export interface DialogContent {
  title: string;
  subtitle: string;
  details: string;
  imagePath: string;
}

export interface FormResultDialogProps {
  open: boolean;
  onClose: () => void;
  dialogContent: DialogContent;
}

/** V2 component */
const FormResultDialog = ({
  open,
  onClose,
  dialogContent,
}: FormResultDialogProps) => {
  const { classes } = useStyles({
    leadCreatedImagePath: dialogContent.imagePath,
  });

  const { title, subtitle, details } = dialogContent;

  return (
    <Dialog open={open} fullWidth maxWidth='lg' onClose={onClose}>
      {/** biome-ignore lint/a11y/useButtonType: Automated migration to Biome */}
      <button className={classes.closeIcon} onClick={onClose}>
        <Icon name={IconName.CLOSE} width={30} />
      </button>
      <div className={classes.leadCreatedModal}>
        <div className={classes.leadCreatedImage} />
        <div className={classes.leadCreatedModalText}>
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
          <Markdown
            urlTransform={(url) =>
              url.startsWith('tel:') ? url : defaultUrlTransform(url)
            }
          >
            {details}
          </Markdown>
        </div>
      </div>
    </Dialog>
  );
};

export default FormResultDialog;
